import { createSelector } from 'reselect';

import { PAGE_CODES } from 'constants/pageCodes';

import { getMasterPermissionsToPage } from 'store/auth/selectors';

import { selectLoanApplication } from './loanApplication.selectors';
import { selectEntitiesChangedPropsByIds } from './loanChangesHistory.selectors';

const getLoanContacts = createSelector(selectLoanApplication, ({ loanContacts }) => loanContacts);

export const selectLoanContacts = createSelector(getLoanContacts, ({ contacts }) => contacts);

export const selectLoanContactsView = createSelector(
  getLoanContacts,
  ({ contactsView }) => contactsView,
);

export const selectLoanContactsPendingChanges = createSelector(
  [selectLoanContactsView, state => state],
  (contactsView, state) => {
    const contactsIds = contactsView.map(({ id }) => id);
    const contactsPendingChanges = selectEntitiesChangedPropsByIds(contactsIds)(state);

    return contactsPendingChanges;
  },
);

export const selectLoanContactsAllowedActions = createSelector(
  getMasterPermissionsToPage(PAGE_CODES.LOAN_EDITOR_CONTACTS),
  allowedActions => allowedActions,
);
